import _ from "lodash";
export const getChangedData = (formData, initialData) => {
  const changedData = {};

  Object.keys(formData).forEach((key) => {
    if (formData[key] !== initialData[key]) {
      if (key == "attchment") {
        changedData[key] = "attachment.pdf";
      } else {
        changedData[key] = formData[key];
      }
    }
  });

  return changedData;
};

export const validateFields = (name, value, setErrors) => {
  if (
    name == "title" ||
    name == "structure" ||
    name == "feeCategory" ||
    name == "amount" ||
    name == "role" ||
    name == "companyName" ||
    name == "name"
  ) {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: !value,
    }));
  }
  setErrors({});
};

export const getCurrentDate = () => {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const year = today.getFullYear();
  return `${year}-${month}-${day}`;
};

export function convertToISOFormat(dateString) {
  let date = new Date(dateString);
  date.setHours(16, 36, 34, 408);
  const timezoneOffset = -date.getTimezoneOffset();
  const offsetHours = Math.floor(Math.abs(timezoneOffset) / 60);
  const offsetMinutes = Math.abs(timezoneOffset) % 60;
  const timezone = `${timezoneOffset >= 0 ? "+" : "-"}${String(
    offsetHours
  ).padStart(2, "0")}:${String(offsetMinutes).padStart(2, "0")}`;
  const formattedDate = date.toISOString().split("T")[0];
  const formattedTime = date.toTimeString().split(" ")[0] + ".408";

  return `${formattedDate} ${formattedTime}${timezone}`;
}

export function snakeCasetoTitleCase(str) {
  return str
    .replace(/(^\w)/g, (g) => g[0].toUpperCase())
    .replace(/([-_]\w)/g, (g) => " " + g[1].toUpperCase())
    .trim();
}

export function camelCaseToTitleCase(str) {
  return str
    .replace(/([A-Z])/g, " $1") // insert space before capital letters
    .replace(/^./, (s) => s.toUpperCase()) // capitalize the first character
    .trim();
}

// export function camelCaseToTitleCase(str) {
//   return _.startCase(str);
// }

export const getStatusColor = (status) => {
  switch (status) {
    case "Done":
      return "success";
    case "In Progress":
      return "warning";
    case "Started":
      return "warning";
    case "On Hold":
      return "warning";
    default:
      return "";
  }
};

// export function snakeCasetoTitleCase(str) {
//   return str
//     .replace(/(^\w)/g, (g) => g[0].toUpperCase())
//     .replace(/([-_]\w)/g, (g) => " " + g[1].toUpperCase())
//     .trim();
// }

// export function camelCaseToTitleCase(str) {
//   return _.startCase(str);
// }

// export const getStatusColor = (status) => {
//   switch (status) {
//     case "Completed":
//       return "success";
//     case "In Progress":
//       return "warning";
//     case "Pending":
//       return "warning";
//     default:
//       return "";
//   }
// };

export const formatHeader = (key) => {
  return key
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^./, (str) => str.toUpperCase());
};

export function formatDate(date) {
  if (!date) return "";
  let newDate = new Date(date);
  const year = newDate.getFullYear();
  const month = String(newDate.getMonth() + 1).padStart(2, "0");
  const day = String(newDate.getDate()).padStart(2, "0");
  return `${day}-${month}-${year}`;
}

export function getFormattedDateOneDayAhead(date) {
  let targetDate;
  if (date) {
    targetDate = new Date(date);
  } else {
    targetDate = new Date();
    targetDate.setDate(targetDate.getDate());
  }
  const year = targetDate.getFullYear();
  const month = String(targetDate.getMonth() + 1).padStart(2, "0");
  const day = String(targetDate.getDate() + 0).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function formatDateTime(dateTimeString) {
  if (!dateTimeString) {
    return "";
  }
  const date = new Date(dateTimeString);
  if (isNaN(date.getTime())) {
    return "";
  }

  const formattedDate = date.toISOString().split("T")[0];
  const formattedTime = date.toLocaleTimeString("en-GB", { hour12: false });

  return `${formattedDate} : ${formattedTime}`;
}

export const excelFormateData = (data) => {
  const updatedData = data.map((item, index) => {
    const updatedObj = {
      OMC: item.omc,
      State: item.stateName,
      City: item.cityName,
      "City Priority": item.cityPriority,
      Package: item.package,
      "SIL Mgmt Approval": item.silManagementApproval,
      "OMC Application": item.omcApplication,
      "OMC NOC Receipt": item.omcNocReceipt,
      "Application to Corporation": item.applicationToCorporation,
      "Corporation NOC Receipt": item.corporationNocReceipt,
      "Release Structure WO": item.releaseStructureWo,
      "Release Foundation WO": item.releaseFoundationWo,
      "Release LED WO": item.releaseLedWo,
      "Lease Agreement": item.leaseAgreement,
      Installation: item.installation,
      Electrification: item.electrification,
      "Go Live": item.goLive,
    };

    return updatedObj;
  });
  return updatedData;
};

export const excelFormateDataForStageSearch = (data) => {
  const updatedData = data.map((item) => {
    return {
      Stage: item.ActivityName,
      OMC: item.omc,
      State: item.stateName,
      City: item.cityName,
      "City Priority": item.cityPriority,
      Package: item.packageName,
      "Principle UID": item.principleuidcode,
      Landmark: item.landmark,
      "Width (ft)": item.Width,
      "Height (ft)": item.Height,
      "Display Area (sqft)": item.DisplayArea,
      "Site Process": item.siteProcess,
    };
  });

  return updatedData;
};
